module.exports = __webpack_public_path__ + "static/media/galerija_2021 (18)-min.09b91fc7.jpg";